var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	"webpack/sharing/consume/default/react/react?cd2a": {
		fallback: () => (__webpack_require__.e("vendors-node_modules_pnpm_react_18_3_1_node_modules_react_index_js").then(() => (() => (__webpack_require__(/*! react */ "./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js"))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^18.3.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	"webpack/sharing/consume/default/react/react?a421": {
		fallback: () => (__webpack_require__.e("vendors-node_modules_pnpm_react_18_3_1_node_modules_react_index_js").then(() => (() => (__webpack_require__(/*! react */ "./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js"))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	"webpack/sharing/consume/default/react/react?7071": {
		fallback: () => (__webpack_require__.e("vendors-node_modules_pnpm_react_18_3_1_node_modules_react_index_js").then(() => (() => (__webpack_require__(/*! react */ "./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js"))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "18.3.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	"webpack/sharing/consume/default/react-dom/react-dom?a7af": {
		fallback: () => (__webpack_require__.e("vendors-node_modules_pnpm_react-dom_18_3_1_react_18_3_1_node_modules_react-dom_index_js").then(() => (() => (__webpack_require__(/*! react-dom */ "./node_modules/.pnpm/react-dom@18.3.1_react@18.3.1/node_modules/react-dom/index.js"))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	"webpack/sharing/consume/default/react/react?b69d": {
		fallback: () => (__webpack_require__.e("vendors-node_modules_pnpm_react_18_3_1_node_modules_react_index_js").then(() => (() => (__webpack_require__(/*! react */ "./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js"))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^17.0.0 || ^18.0.0 || ^19.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	"webpack/sharing/consume/default/react/react?7612": {
		fallback: () => (__webpack_require__.e("vendors-node_modules_pnpm_react_18_3_1_node_modules_react_index_js").then(() => (() => (__webpack_require__(/*! react */ "./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js"))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: ">=16.8.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	"webpack/sharing/consume/default/react/react?18c4": {
		fallback: () => (__webpack_require__.e("vendors-node_modules_pnpm_react_18_3_1_node_modules_react_index_js").then(() => (() => (__webpack_require__(/*! react */ "./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js"))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: ">=16.6.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	"webpack/sharing/consume/default/react-dom/react-dom?856b": {
		fallback: () => (__webpack_require__.e("vendors-node_modules_pnpm_react-dom_18_3_1_react_18_3_1_node_modules_react-dom_index_js").then(() => (() => (__webpack_require__(/*! react-dom */ "./node_modules/.pnpm/react-dom@18.3.1_react@18.3.1/node_modules/react-dom/index.js"))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: ">=16.6.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	"webpack/sharing/consume/default/react-dom/react-dom?12c6": {
		fallback: () => (__webpack_require__.e("vendors-node_modules_pnpm_react-dom_18_3_1_react_18_3_1_node_modules_react-dom_index_js").then(() => (() => (__webpack_require__(/*! react-dom */ "./node_modules/.pnpm/react-dom@18.3.1_react@18.3.1/node_modules/react-dom/index.js"))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^17.0.0 || ^18.0.0 || ^19.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	"webpack/sharing/consume/default/react/react?490b": {
		fallback: () => (__webpack_require__.e("vendors-node_modules_pnpm_react_18_3_1_node_modules_react_index_js").then(() => (() => (__webpack_require__(/*! react */ "./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js"))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: ">= 16.8.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	"webpack/sharing/consume/default/react/react?dc7a": {
		fallback: () => (__webpack_require__.e("vendors-node_modules_pnpm_react_18_3_1_node_modules_react_index_js").then(() => (() => (__webpack_require__(/*! react */ "./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js"))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: ">=16.9.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	"webpack/sharing/consume/default/react/react?a3d4": {
		fallback: () => (__webpack_require__.e("vendors-node_modules_pnpm_react_18_3_1_node_modules_react_index_js").then(() => (() => (__webpack_require__(/*! react */ "./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js"))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: ">=16.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	"webpack/sharing/consume/default/react-dom/react-dom?3937": {
		fallback: () => (__webpack_require__.e("vendors-node_modules_pnpm_react-dom_18_3_1_react_18_3_1_node_modules_react-dom_index_js").then(() => (() => (__webpack_require__(/*! react-dom */ "./node_modules/.pnpm/react-dom@18.3.1_react@18.3.1/node_modules/react-dom/index.js"))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: ">=16.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	"webpack/sharing/consume/default/react/react?563b": {
		fallback: () => (__webpack_require__.e("vendors-node_modules_pnpm_react_18_3_1_node_modules_react_index_js").then(() => (() => (__webpack_require__(/*! react */ "./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js"))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: ">= 16.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	"webpack/sharing/consume/default/react/react?b1ee": {
		fallback: () => (__webpack_require__.e("vendors-node_modules_pnpm_react_18_3_1_node_modules_react_index_js").then(() => (() => (__webpack_require__(/*! react */ "./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js"))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^18 || ^19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	"webpack/sharing/consume/default/react-dom/react-dom?7a84": {
		fallback: () => (__webpack_require__.e("vendors-node_modules_pnpm_react-dom_18_3_1_react_18_3_1_node_modules_react-dom_index_js").then(() => (() => (__webpack_require__(/*! react-dom */ "./node_modules/.pnpm/react-dom@18.3.1_react@18.3.1/node_modules/react-dom/index.js"))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: ">=16.9.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	"webpack/sharing/consume/default/react/react?8284": {
		fallback: () => (__webpack_require__.e("vendors-node_modules_pnpm_react_18_3_1_node_modules_react_index_js").then(() => (() => (__webpack_require__(/*! react */ "./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js"))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^18.0.0 || ^19.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"webpack_sharing_consume_default_react_react-_cd2a": [
		"webpack/sharing/consume/default/react/react?cd2a"
	],
	"src_bootstrap_tsx-webpack_sharing_consume_default_react-dom_react-dom-webpack_sharing_consume-76906a": [
		"webpack/sharing/consume/default/react/react?a421",
		"webpack/sharing/consume/default/react/react?7071",
		"webpack/sharing/consume/default/react-dom/react-dom?a7af",
		"webpack/sharing/consume/default/react/react?b69d",
		"webpack/sharing/consume/default/react/react?7612",
		"webpack/sharing/consume/default/react/react?18c4",
		"webpack/sharing/consume/default/react-dom/react-dom?856b",
		"webpack/sharing/consume/default/react-dom/react-dom?12c6",
		"webpack/sharing/consume/default/react/react?490b",
		"webpack/sharing/consume/default/react/react?dc7a",
		"webpack/sharing/consume/default/react/react?a3d4",
		"webpack/sharing/consume/default/react-dom/react-dom?3937",
		"webpack/sharing/consume/default/react/react?563b",
		"webpack/sharing/consume/default/react/react?b1ee"
	],
	"webpack_sharing_consume_default_react-dom_react-dom": [
		"webpack/sharing/consume/default/react-dom/react-dom?7a84"
	],
	"webpack_sharing_consume_default_react_react-_8284": [
		"webpack/sharing/consume/default/react/react?8284"
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}